export const ROUTES = {
  home: '/',
  courses: '/courses',
  courseDetail: (slug) => `/courses/${slug}`,
  instructors: '/instructors',
  instructorProfile: (slug) => `/instructors/${slug}`,
  enroll: '/enroll',
  contact: '/contact',
  helpCenter: '/helpCenter',
  faqs: '/faqs',
  about: '/about',
  blog: '/blog',
  blogPost: (slug) => `/blog/${slug}`,
  press: '/press',
  careers: '/careers',
  community: '/community',
  becomeInstructor: '/becomeInstructor',
  teachingCenters: '/teachingCenters',
  resources: '/resources',
  signIn: '/signIn',
  signUp: '/signUp',
  signUpWithRole: (role) => `/signUp?role=${role}`,
  enrollmentSetup: '/enrollmentSetup',
  availabilitySetup: '/availabilitySetup',
  chooseVerificationMethod: '/chooseVerificationMethod',
  verifyAccount: '/verifyAccount',
  forgotPassword: '/forgotPassword',
  verifyResetCode: '/verifyResetCode',
  resetPassword: '/resetPassword',
  promotion: '/promotion/dfw',
  promotionRegion: (region) => `/promotion/${region}`,
  promotionEnrollment: '/promotionEnrollment',
  promotionProfile: '/promotionProfile',
  promotionAvailability: '/promotionAvailability',
  promotionContact: '/promotionContact',
  promotionConfirmation: '/promotionConfirmation',
  guardianPortal: '/portal/guardian',
  instructorPortal: '/portal/instructor',
  studentPortal: '/portal/student',
};